import scroll from './locoScroll';
import detectTouch from './lib/detectTouch';

export default class BubbleManager {
  constructor(node, linkNodes) {
    this.node = node;

    this.linkNodes = linkNodes;

    this.isHover = false;
    this.isActive = false;

    this.x = 0;
    this.y = 0;

    this.addLinkListeners();
    
    window.addEventListener('mousemove', this.mousemove.bind(this));
    window.requestAnimationFrame(this.tick.bind(this));
    scroll.on('scroll', this.scroll.bind(this))
  }

  mousemove(event) {
    this.x = event.clientX;
    this.y = event.clientY;
  }

  scroll() {
    if (detectTouch() && this.isActive) {
      this.hide();
      this.close();
      this.isHover = false; 
      this.isActive = false;
    }
  }

  tick() {
    if (detectTouch()) {
      this.x = window.innerWidth / 2;
      this.y = window.innerHeight / 2;
    }
    this.node.style.transform = `translate(${this.x}px, ${this.y + scroll.scroll.instance.scroll.y}px)`;
    window.requestAnimationFrame(this.tick.bind(this));
  }

  addLinkListeners() {
    [...this.linkNodes].forEach(link => {
      link.addEventListener('mouseenter', () => { 
        this.isHover = true; 
        this.show();
      })
      link.addEventListener('mouseleave', () => { 
        this.isHover = false; 
        this.isActive = false; 
        this.hide();
        this.close();
      })
      link.addEventListener('click', (event) => { 
        event.preventDefault();
        
        this.isActive = true; 
        this.show();
        this.open();
      })
    })
  }

  show() {
    this.node.style.opacity = 1;
  }

  hide() {
    this.node.style.opacity = 0;
  }

  open() {
    this.node.classList.add('is-active');
  }

  close() {
    this.node.classList.remove('is-active');
  }
}
